
<app-sub-header 
[header]="header"
[currentStage]="currentStage"
[totalStage]="totalStage"

></app-sub-header>

<!-- <app-sub-header  *ngIf="minTab == 2"
[header]="'Confirm Your Address Details.'"
[currentStage]="2"
[totalStage]="19"
></app-sub-header> -->

<section class="main-container main-container-super">
  <div class="container container-super user-form-page">
    <!-- <ng-container *ngIf="minTab == 1">
      <h2 class="heading-title text-center">
        {{header}}
      </h2></ng-container>

    <ng-container *ngIf="minTab == 2">
      <h2 class="heading-title text-center">Confirm Your Address Details.</h2>
      </ng-container>  -->



    <div class="form-content-box">
      <!-- <h3 class="title">Take your first steps with Cashel Family Office</h3> -->
      <!-- <p>Before we can provide credit assistance advice, we need to understand your current situation and goals.
        Please complete the forms below.</p> -->




      <p class="sub-para" *ngIf="!auth.IsAuthUser()">
        Already a Cashel Family Office Client?
        <a style="cursor: pointer;" (click)="openDialog('LOGIN TO YOUR ACCOUNT')">Log In</a>
      </p>



      <h3 class="title sub-para" *ngIf="auth.IsAuthUser()">
        Dear {{ auth.getLoginUserName()}},
      </h3>
      <!-- <div class="box-labelsuper" *ngIf="minTab == 2">
        <h4>Please confirm your address details</h4>

      </div> -->
      <!-- <p class="sub-para" *ngIf="auth.IsAuthUser()"> <a (click)="logout()">Logout
          here</a></p> -->
    </div>

    <form
      [formGroup]="applicationForm"
      (ngSubmit)="onSubmit()"
      *ngIf="minTab == 1"
    >
      <div class="box box-super">
        <div class="box-labelsuper">
          <h4>Please enter your details below.</h4>
        </div>
        <div class="form-box">
          <div class="row">
            <div class="col m6 s12">
              <div class="field-group">
                <mat-label class="labelsuper-normal">First Name</mat-label>
                <mat-form-field appearance="outline" class="custom-form-field">
                 <input
                    formControlName="firstname"
                    matInput
                    placeholder="Enter first name" required
                  >
                  <!-- <mat-error *ngIf="
                  submitted &&
                  applicationF.firstname.errors &&
                  applicationF.firstname.errors.required
                ">
                First name is required
 </mat-error> -->
                </mat-form-field>
                <!-- <p
                  *ngIf="
                    submitted &&
                    applicationF.firstname.errors &&
                    applicationF.firstname.errors.required
                  "
                  class="red-text error-message"
                >
                  First name is required
                </p> -->
                <!-- <p
                  *ngIf="
                    submitted &&
                    applicationF.firstname.errors &&
                    applicationF.firstname.errors.maxlength
                  "
                  class="red-text error-message"
                >
                  First name is less than 15 character
                </p> -->
              </div>
            </div>
            <div class="col m6 s12">
              <div class="field-group">
                <mat-label class="labelsuper-normal">Family Name</mat-label>
                <mat-form-field appearance="outline" class="custom-form-field">
                <input
                    matInput
                    formControlName="lastname"
                    placeholder="Enter Family name"
                  />
                </mat-form-field>
                <!-- <mat-error
                  *ngIf="
                    submitted &&
                    applicationF.lastname.errors &&
                    applicationF.lastname.errors.required
                  "
                >
                  Family name is required
                </mat-error>
                <p
                  *ngIf="
                    submitted &&
                    applicationF.lastname.errors &&
                    applicationF.lastname.errors.maxlength
                  "
                  class="red-text error-message"
                >
                  Family name is less than 15 character
                </p> -->
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col m6 s12" >
              <div class="field-group">
                <mat-label class="labelsuper-normal">Mobile Phone</mat-label>
                <mat-form-field   appearance="outline" class="custom-form-field  mobileInput " >
               
                  <input *ngIf="showMobileInput; else duplicateInput1"  matInput mobileInput placeholder="9990097745" maxlength="10" formControlName="mobilephone" />
                  <ng-template #duplicateInput1>  <input   matInput mobileInput placeholder="9990097745" maxlength="10" formControlName="mobilephone" /></ng-template>
               
                  <!-- <app-tel-input [mobileTouched]="mobileTouched" matInput formControlName="mobilephone"></app-tel-input> -->
                  <mat-icon matSuffix>phone</mat-icon>
                </mat-form-field>
<!--
                <p
                  *ngIf="
                    submitted &&
                    applicationF.mobilephone.errors &&
                    applicationF.mobilephone.errors.required
                  "
                  class="red-text error-message"
                >
                  Phone number is required
                </p>
                <p
                  *ngIf="
                    submitted &&
                    applicationF.mobilephone.errors &&
                    applicationF.mobilephone.errors.pattern
                  "
                  class="red-text error-message"
                >
                  Phone number is number only
                </p>
                <p
                  *ngIf="
                    submitted &&
                    applicationF.mobilephone.errors &&
                    applicationF.mobilephone.errors.minlength
                  "
                  class="red-text error-message"
                >
                  Phone number is less than 10 character
                </p>
                <p
                  *ngIf="
                    submitted &&
                    applicationF.mobilephone.errors &&
                    applicationF.mobilephone.errors.maxlength
                  "
                  class="red-text error-message"
                >
                  Phone number is greater than 10 character
                </p> -->
              </div>
            </div>
            <div class="col m6 s12">
              <div class="field-group">
                <mat-label class="labelsuper-normal">Email</mat-label>
                <mat-form-field  appearance="outline" class="custom-form-field">
                 <input
                    matInput
                    placeholder="yourmail@domain.com"
                    formControlName="emailaddress1"
                    (keyup)="onEmailKeyup()"
                  />
                  <mat-icon matSuffix>email</mat-icon>
                </mat-form-field>
                <!-- <p
                  *ngIf="
                    submitted &&
                    applicationF.emailaddress1.errors &&
                    applicationF.emailaddress1.errors.required
                  "
                  class="red-text error-message"
                >
                  Email  is required
                </p>
                <p
                  *ngIf="
                    submitted &&
                    applicationF.emailaddress1.errors &&
                    applicationF.emailaddress1.errors.pattern
                  "
                  class="red-text error-message"
                >
                  Email is not validate
                </p> -->
              </div>
            </div>
          </div>
          <div class="row">
            
            <div class="col m6 s12">
              <div class="field-group">
                <mat-label class="labelsuper-normal">Date of Birth </mat-label>
                <mat-form-field color="accent" 
                  appearance="outline" class="custom-form-field"
                >
               <input
                    matInput
                    [matDatepicker]="picker1"
                    [max]="todayDate"
                    formControlName="birthdate"
                    (dateInput)="addEvent('input', $event)"
                    (dateChange)="addEvent('change', $event)"
                   placeholder="DD/MM/YYYY"
                  />              

                  <mat-datepicker-toggle class="calender-icon"
                    matSuffix
                    [for]="picker1"

                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
                <!-- <p
                  *ngIf="
                    submitted &&
                    applicationF.birthdate.errors &&
                    applicationF.birthdate.errors.required
                  "
                  class="red-text error-message"
                >
                  Date of Birth is required
                </p> -->
              </div>
            </div>
            <div class="col m6 s12">
              <div class="field-group radio-btns radio-mob" [ngClass]="{redBorder: isredColor}">
                <mat-label class="labelsuper-normal">Gender</mat-label>
                <mat-radio-group
                  aria-label="Select an option"
                  formControlName="gendercode"
                >
                  <mat-radio-button value="1">Male</mat-radio-button>
                  <mat-radio-button value="2">Female</mat-radio-button>
                </mat-radio-group>
                <!-- <p
                  *ngIf="
                    submitted &&
                    applicationF.gendercode.errors &&
                    applicationF.gendercode.errors.required
                  "
                  class="red-text error-message"
                >
                  Gender is required
                </p> -->
              </div>
            </div>
          </div>
          <div class="row">


            <div class="col m6 s12">
              <div class="field-group selectfield">
                <mat-label class="labelsuper-normal">Australian Residential Status:</mat-label>
                <mat-form-field appearance="fill" class="selectfield">
                  <mat-select
                    [(value)]="selected"
                    formControlName="tlx_residentialstatus"
                    placeholder="Select"
                  >
                    <mat-option value="{{ citizenShip.CITIZEN }}"
                      >Citizen</mat-option
                    >
                    <mat-option value="{{ citizenShip.RESIDENT }}"
                      >Resident</mat-option
                    >
                    <mat-option value="{{ citizenShip.NON_RESIDENT }}"
                      >Non-Resident</mat-option
                    >
                  </mat-select>
                  <!-- <p
                    *ngIf="
                      submitted &&
                      applicationF.tlx_residentialstatus.errors &&
                      applicationF.tlx_residentialstatus.errors.required
                    "
                    class="red-text error-message"
                  >
                    Residential status is required
                  </p> -->
                </mat-form-field>
              </div>
            </div>

            <div class="col m6 s12">
              <div class="field-group radio-btns pb-13"   [ngClass]="{redBorder: isredColor}">
                <mat-label class="labelsuper-normal">Are you an Australian Tax resident?</mat-label>
                <mat-radio-group              
                  aria-label="Select an option"
                  formControlName="tlx_australiantaxresident"
                >
                  <mat-radio-button [value]="true">Yes &nbsp; </mat-radio-button>
                  <mat-radio-button [value]="false">No</mat-radio-button>
                </mat-radio-group>
                <!-- <p
                  *ngIf="
                    submitted &&
                    applicationF.tlx_australiantaxresident.errors &&
                    applicationF.tlx_australiantaxresident.errors.required
                  "
                  class="red-text error-message"
                >
                  Are you an Australian Tax resident is required
                </p> -->
              </div>
            </div>
          </div>

          <!-- <div class="row">

          </div>
          <div class="row">

          </div> -->
               <!-- [ngStyle]="{borderColor: 'red'}" -->
          <div class="margin-top2">
            <mat-checkbox
              formControlName="isAgree"
              value="1"
         [ngClass]="{redBorder: isredColor}"
            ></mat-checkbox>
            <span class="acknowledge">
              &nbsp; I agree and accept the Privacy Policy and acknowledge the
              <a
                href="https://cashelfo.com/wp-content/uploads/2021/01/FSG-Cashel-Family-Office-v3.4-20200403.pdf"
                target="_blank"
              >
                Cashel Financial Services Guide</a
              >,
              <a
                href="https://cashelfo.com/wp-content/uploads/2021/01/Cashel-DPS-Credit-V1-0716-AMason.pdf"
                target="_blank"
                >Cashel Credit Guide</a
              >
              and
              <a
                target="_blank"
                href="https://cashelfo.com/privacy-policy/"
                >Privacy Policy</a
              >.
            </span>
            <!-- <p
            *ngIf="
              submitted &&
              applicationForm.value.isAgree == false &&
              applicationForm.value.isAgree == ''
            "
            class="red-text error-message"
          >
            Please accept Terms and Privacy Policy.
          </p> -->
          </div>

        </div>

        <!-- <ng-container *ngIf="loading === true"> <mat-progress-bar mode="indeterminate"></mat-progress-bar> </ng-container> -->

      </div>

       <div class="button-footer">
        <button style="visibility: hidden;"
        mat-flat-button
        class="width-100 green pull-left previous-button previous-hide-btn"
      >
        Previous
      </button> 
        <button mat-flat-button class=" green pull-right start-btn" >Start Application</button>
          <!-- <button mat-button matStepperNext>Next</button> -->
      </div>
<!-- only for superannuation cases -->
      <!-- <div class="footer-para ">
        <mat-label>* For Cashel to conduct a Super search, you must be a member of Cashel Super. Our search results typically yield lost, unclaimed and active
           superannuation accounts. Initial and ongoing fees will apply if you roll over all or some of your existing superannuation into Cashel Super, either 
           independently or after we find your super. You should note the insurance you have with your existing accounts and note that you may not be able to 
           obtain the same entitlements (you may either gain or lose insurance coverage) from Cashel Super.
        </mat-label>

        <mat-label class="margin-top1">Membership of Cashel Super is subject to the <a href="">Cashel Super Product Disclosure Statement, Cashel Privacy Policy, Cashel Financial ServicesGuide, 
          Cashel Credit Guide</a> </mat-label>
        <mat-label class="margin-top1">Interest in Cashel Super and Pension, a division of the Aracon Master Super Fund issued by Aracon Superannuation Pty Ltd (ABN 13 133 547 396RSE License 
          L0003384 AFSL 507184). Before making any decisions you should consider how appropriate this product is for your own personal financial circumstances. Information on this website has 
          been prepared without taking into account your personal circumstances.</mat-label>

      </div> -->

    </form>

    <form
  
      [formGroup]="addressForm"
           *ngIf="minTab == 2"
    >
      <div class="box box-super">
        
        <div class="form-box">
          <div class="box-labelsuper">
            <h4>Current Home Address</h4>
          </div>
          <app-address
            [parentForm]="addressForm.controls.homeAddress"
            [number]="0"
            [formSubmit]="addressSubmit"
          >
          </app-address>

          <div class="row">
            <div class="col l3 m4 s12">
              <div class="field-group ">
                <mat-label >Date commenced at this address</mat-label>
                <mat-form-field
                appearance="outline" class="custom-form-field"
                >
                  <input
                    matInput
                    [matDatepicker]="picker2"
                    placeholder="DD/MM/YYYY"
                    formControlName="dateCommenced"
                  
                  />

                  <mat-datepicker-toggle class="calender-icon"
                    matSuffix
                    [for]="picker2"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </div>
          <!--Current Home Address-->
          <div
            class="box-labelsuper"
            [ngClass]="isShowAddress ? 'isShow' : 'isHide'"
          >
            <h4>Previous Home Address</h4>
          </div>
          <app-address
            [parentForm]="addressForm.controls.previousAddress"
            [number]="1"
            [formSubmit]="addressSubmit"
            [ngClass]="isShowAddress ? 'isShow' : 'isHide'"
          >
          </app-address>
          <div class="box-labelsuper address-top-margin">
            <h4>Postal Address</h4>
          </div>
          <div class="row">
            <div class="col m6 s12">
              <div class="field-group radio-btns">
                <mat-label
                  >Is your current address the same as your postal address?
                </mat-label>
                <mat-radio-group class="margin-bottom1"
                  aria-label="Select an option"
                  formControlName="tlx_sameashomeaddress"
                  (change)="checkPostalAddress($event)"
                >
                  <mat-radio-button value="true"
                    >Yes</mat-radio-button
                  >
                  <mat-radio-button value="false" >No</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>
          <!--Previous Home Address-->
          
          <ng-container *ngIf="addressForm.value.tlx_sameashomeaddress=='false'">
            <app-address
              [parentForm]="addressForm.controls.postalAddress"
              [number]="2"
              [formSubmit]="addressSubmit"
            >
            </app-address>
          </ng-container>

          <!--Postal Address-->

          <!-- <div class="box-labelsuper">
            <h4>Privacy Consent</h4>
          </div> -->
          <!-- <div class="row">
            <div class="col m4 s12">
              <div class="field-group radio-btns pb-13">
                <mat-label class="labelsuper-normal">Privacy Consent</mat-label>
                <mat-radio-group aria-label="Select an option" formControlName="tlx_privacyconsent">
                  <mat-radio-button [value]=true>Yes</mat-radio-button>
                  <mat-radio-button [value]=false>No</mat-radio-button>
                </mat-radio-group>
                <p *ngIf="submitted && applicationF.tlx_privacyconsent.errors && applicationF.tlx_privacyconsent.errors.required"
                  class="red-text error-message">Privacy Consent is required</p>
              </div>
            </div>

            <div class="col m4 s12">
              <div class="field-group">
                <mat-label class="labelsuper-normal">Privacy Consent Date</mat-label>
                <mat-form-field color="accent" appearance="fill" class="datepicker">
                  <input matInput [matDatepicker]="picker1" [max]="todayDate" formControlName="tlx_privacyconsentdate"
                    placeholder="11/5/2000" (dateInput)="addEvent('input', $event)"
                    (dateChange)="addEvent('change', $event)">
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
                <p *ngIf="submitted && applicationF.tlx_privacyconsentdate.errors && applicationF.tlx_privacyconsentdate.errors.required"
                  class="red-text error-message">Privacy Consent Date is  required.</p>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <!-- <pre>Form Values: {{addressForm.getRawValue() | json}}</pre> -->

  
      <div class="button-footer">
        <button
          mat-flat-button
          class="width-100 green pull-left previous-button"
          (click)="goPrevious()"
          type="button"
        >
          <!-- Previous -->
        </button>
        <!-- <button mat-button matStepperNext>Next</button> -->
        <button
          mat-flat-button
          class="width-200 green pull-right"
          style="float: right"
          type="button"
          (click)="onAddressSubmit()"
        >
          <!-- Commence Debt Application -->
          Next
        </button>
      </div>
    </form>
    <!--!Step-->
  </div>
</section>
